export enum LangueEnum {
  FR = 'fr',
  EN = 'en',
}
